let isFirstRefresh = true;

document.addEventListener('facetwp-refresh', () => {
	if (isFirstRefresh) {
		isFirstRefresh = false;
		return;
	}

	// There should only be one .facetwp-template, so this is fine.
	document.querySelector('section:has(.facetwp-template)')?.scrollIntoView();
});
